import { LineChart } from "@mui/x-charts/LineChart";
import dayjs from "dayjs";
interface chartProps {
  xAxisData: (string | Date | number)[];
  yAxisData: any[];
  isLoading: boolean;
  dateDifference: number;
  isCurrency?: boolean;
}
export const AppLineChart: React.FunctionComponent<chartProps> = ({
  xAxisData,
  yAxisData,
  isLoading,
  dateDifference,
  isCurrency,
}) => {
  const formattedDates = (value: string | Date | number) => {
    if (dateDifference < 1) {
      // Format for ranges less than 1 day
      return dayjs(value).format("HH:mm A");
    } else if (dateDifference < 300) {
      // Format for ranges between 1 and 300 days
      return dayjs(value).format("DD-MMM");
    } else {
      // Format for ranges >= 300 days
      return dayjs(value).format("DD-MMM-YYYY");
    }
  };

  const tooltipFormatter = (value: string | Date | number) => {
    const index = xAxisData.indexOf(value);
    const toDateCalculation =
      index < xAxisData.length - 1
        ? dayjs(xAxisData[index + 1]).subtract(1, "day")
        : dayjs(value);

    const formatDates = (format: string) => ({
      fromDate: dayjs(value).format(format),
      toDate: toDateCalculation.format(format),
    });

    let dateRange;
    if (dateDifference < 1) {
      dateRange = formatDates("HH:mm A");
    } else if (dateDifference < 300) {
      dateRange = formatDates("DD-MMM");
    } else {
      dateRange = formatDates("DD-MMM-YYYY");
    }

    return index < xAxisData.length - 1
      ? `${dateRange.fromDate} to ${dateRange.toDate}`
      : `${dateRange.toDate}`;
  };

  return (
    <LineChart
      loading={isLoading}
      xAxis={[
        {
          scaleType: "band",
          data: xAxisData,
          valueFormatter: (value, context) =>
            context.location === "tooltip"
              ? tooltipFormatter(value)
              : formattedDates(value),
        },
      ]}
      series={[
        {
          data: yAxisData,
        },
      ]}
      yAxis={[
        {
          valueFormatter: (value) =>
            isCurrency ? `$${(value / 1000).toLocaleString("en-us")}k` : value,
        },
      ]}
      height={300}
    />
  );
};
